import * as t from './actionTypes';
import { SentMessageReducerState } from './types';
import {
  fetchSentMessageRequest,
  fetchSentMessageError,
  fetchSentMessageResponse,
} from './actions';

export const initialSentMessageState: SentMessageReducerState['sentMessage'] = {
  isFetchingSentMessage: false,
  sentMessage: {
    bccEmails: [],
    ccEmails: [],
    dataFeeds: [],
    fromEmail: '',
    fromName: '',
    html: '',
    isStored: false,
    messageMedium: '',
    plainText: '',
    recipient: '',
    subject: '',
  },
};

type SendMessageReducerAction =
  | ReturnType<typeof fetchSentMessageRequest>
  | ReturnType<typeof fetchSentMessageError>
  | ReturnType<typeof fetchSentMessageResponse>;

export const sentMessageReducer = (
  state = initialSentMessageState,
  action: SendMessageReducerAction,
) => {
  switch (action.type) {
    case t.FETCH_SENT_MESSAGE_REQUEST:
      return {
        ...state,
        isFetchingSentMessage: true,
      };
    case t.FETCH_SENT_MESSAGE_ERROR:
      return {
        ...state,
        isFetchingSentMessage: false,
      };
    case t.FETCH_SENT_MESSAGE_RESPONSE:
      return {
        isFetchingSentMessage: false,
        sentMessage: action.response.data,
      };
    default:
      return state;
  }
};
